module.exports = {
  "info": "INFO",
  "menu": "MENU",
  "delivery": "DELIVERY",
  "hours": "HOURS",
  "dinner": "DINNER - Monday to Sunday 5pm-close",
  "reservations": "RESERVATIONS",
  "information": "INFORMATION",
  "phone": "(514) 933-9433",
  "meat": "MEAT",
  "wild-bass-crudo": "WILD BASS CRUDO",
  "wild-bass-crudo-desc": "avocado, micro coriander",
  "dinner_menu": "DINNER MENU",
  "raw-bar": "RAW BAR",
  "mixed-oysters": "MIXED OYSTERS",
  "six": "six",
  "twelve": "twelve",
  "shrimp-cocktail": "SHRIMP COCKTAIL",
  "six-shrimp": "six shrimp",
  "snow-crab-cocktail": "SNOW CRAB COCKTAIL",
  "half": "half",
  "full": "full",
  "lobster-cocktail": "LOBSTER COCKTAIL",
  "seafood": "SEAFOOD",
  "seafood-platter": "SEAFOOD PLATTER",
  "small": "small",
  "seafood-platter-small-desc": "nine oysters, four shrimp,",
  "seafood-platter-small-desc-two": "half crab, half lobster",
  "large": "large",
  "seafood-platter-large-desc": "eighteen oysters, six shrimp,",
  "seafood-platter-large-desc-two": "full crab, full lobster",
  "bloody-caesar": "LUCILLE'S SEAFOOD BLOODY CAESAR",
  "bloody-caesar-desc": "classic bloody caesar with an oyster,",
  "bloody-caesar-desc-two": "a shrimp, and a crab leg",
  "starters": "STARTERS",
  "kale-salad": "KALE SALAD",
  "kale-salad-desc": " sweet corn, parmesan",
  "cajun-shrimp-salad": "CAJUN SHRIMP SALAD",
  "cajun-shrimp-salad-desc": " avocado",
  "tuna-sashimi": "TUNA SASHIMI",
  "tuna-sashimi-desc": " ponzu sauce, chimichurri",
  "wedge-salad": "WEDGE SALAD",
  "wedge-salad-desc": " blue cheese, smoked bacon, pickles",
  "salmon-tartare": "SALMON TARTARE",
  "salmon-tartare-desc": " asian-style, lettuce wraps, crispy rice noodles",
  "beet-salad": "BEET SALAD",
  "beet-salad-desc": " mozzarella, apple, crostini, spiced chickpeas",
  "tuna-tartare": "TUNA TARTARE",
  "tuna-tartare-desc": " avocado, soya",
  "caesar-salad": "CAESAR SALAD",
  "caesar-salad-desc": " romaine, cajun chips, pickled red onions, pickles",
  "black-angus-beef": "BLACK ANGUS BEEF TARTARE",
  "black-angus-beef-desc": " mustard seed, pickles, panko, mi-cuit egg",
  "fish-tacos": "FISH TACOS",
  "fish-tacos-desc": " tomatillo, mango puree, red cabbage",
  "mykonos-greek-salad": "MYKONOS GREEK SALAD",
  "mykonos-greek-salad-desc": " heirloom tomatoes, goat's milk feta",
  "roasted-cauliflower": "ROASTED CAULIFLOWER",
  "roasted-cauliflower-desc": " cherry tomatoes, parmesan",
  "steamed-clams": "STEAMED CLAMS",
  "steamed-clams-desc": " garlic, white wine",
  "chopped-salad": "CHOPPED SALAD",
  "chopped-salad-desc": " fattoush dressing, radish, cucumber, cherry tomatoes",
  "crispy-calamari": "CRISPY CALAMARI",
  "crispy-calamari-desc": " malt vinegar aioli",
  "pasta": "PASTA",
  "lobster-cavatelli": "LOBSTER CAVATELLI",
  "lobster-cavatelli-desc": " lobster bisque, lemon mascarpone",
  "chicken-parmesan": "CHICKEN PARMESAN",
  "chicken-parmesan-desc": " mozzarella di bufala",
  "penne-rose": "PENNE ROSÉ",
  "penne-rose-desc": " pureed tomato, mozzarella, parmesan",
  "mixed-grilled-seafood": "MIXED GRILLED SEAFOOD",
  "mixed-grilled-seafood-desc": " calamari, octopus, shrimp",
  "shrimp-brochette": "SHRIMP BROCHETTE",
  "shrimp-brochette-desc": " lemon chilli glaze, tortillas",
  "grilled-octopus": "GRILLED OCTOPUS",
  "grilled-octopus-desc": " greek salad",
  "salmon-filet": "PAN-SEARED SALMON FILET",
  "salmon-filet-desc": " cucumber, greek yogurt, dill",
  "lobster-salad": "LOBSTER SALAD",
  "lobster-salad-desc": " celery, apple, shrimp spring roll",
  "whole-grilled-lobster": "WHOLE GRILLED LOBSTER",
  "whole-grilled-lobster-desc": " mixed green salad, fries",
  "branzino-filet": "BRANZINO FILET",
  "branzino-filet-desc": " on chopped salad",
  "lobster-rolls": "LOBSTER ROLLS",
  "lobster-rolls-desc": " homecut fries",
  "taco-board": "TACO BOARD",
  "taco-board-desc": " beef, chicken, shrimp, guacamole",
  "veal-milanese": "VEAL MILANESE",
  "veal-milanese-desc": " balsamic glaze, avocado salad",
  "portuguese-chicken": "PORTUGUESE CHICKEN",
  "portuguese-chicken-desc": " cabbage slaw",
  "junior-burgers": "TWO JUNIOR BURGERS",
  "junior-burgers-desc": " hand-ground ribsteak, fries",
  "baby-back-ribs": "BABY BACK RIBS",
  "baby-back-ribs-desc": " homecut fries",
  "surf-turf": "SURF & TURF",
  "surf-turf-desc": " single lobster roll, ribs, fries",
  "steaks": "STEAKS",
  "with-fries": "served with fries or salad",
  "filet-mignon": "FILET MIGNON",
  "kansas-cut": "KANSAS CUT",
  "tbone": "T-BONE",
  "ribsteak": "RIBSTEAK",
  "steaks-for-two": "steaks for two",
  "porterhouse": "PORTERHOUSE",
  "cote-de-boeuf": "CÔTE DE BOEUF",
  "chateaubriand": "CHATEAUBRIAND",
  "pepper-sauce": "PEPPER SAUCE",
  "sides": "SIDES",
  "homecut-fries": "Homecut Fries",
  "sweet-potato-fries": "Sweet Potato Fries",
  "cheesy-mash": "Cheesy Mash",
  "small-greek-salad": "Small Greek Salad",
  "grilled-vegetables": "Grilled Vegetables",
  "onion-rings": "Onion Rings",
  "side-caesar-salad": "Side Caesar Salad",
  "mixed-green-salad": "Mixed Green Salad",
  "avocado-salad": "Avocado Salad",
  "copyright": "Copyright © 2017 Brasserie Lucille's. All rights reserved.",
  "description": "Our famous lobster roll and mouth watering seafood. In-house dry aged and charcoal grilled steaks. Indulge in a night out at Brasserie Lucille's restaurant.",

  "branzino-crudo": "BRANZINO CRUDO",
  "branzino-crudo-desc": " olive oil, sea salt, lemon",
  "miami-short-rib": "MIAMI SHORT RIB",
  "miami-short-rib-desc": " dashi broth, tofu, baby kale",
  "singapore-slaw-salad": "LUCILLES'S 19-INGREDIENT SINGAPORE SLAW SALAD",
  "singapore-slaw-salad-desc": "",
  "roasted-bass-filet": "ROASTED BASS FILET",
  "roasted-bass-filet-desc": " jumbo asparagus and basil salad",
  "bookenda-url": "https://www.bookenda.com/brasserie-lucilles?PartnerNumber=1&IdClientApplication=2427&IdServiceOccurence=0&Language=English#Reservation",
  "bookenda-image": "http://www.bookenda.com/Images/badge-booknow_book_EN.png",
}




// WEBPACK FOOTER //
// ../public/messages/en-US.js